"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerceivedImpulse = void 0;
/**
 * Impulse which indicates the result of a perceive impulse.
 */
var PerceivedImpulse = /** @class */ (function (_super) {
    __extends(PerceivedImpulse, _super);
    function PerceivedImpulse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "PerceivedImpulse";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return PerceivedImpulse;
}(Array));
exports.PerceivedImpulse = PerceivedImpulse;
//# sourceMappingURL=PerceivedImpulse.js.map